"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINIMUM_PROBLEM_SET_SIZE = exports.ProblemSetType = exports.PracticeProblemType = void 0;
var PracticeProblemType;
(function (PracticeProblemType) {
    PracticeProblemType["SHORT_ANSWER"] = "SHORT_ANSWER";
    PracticeProblemType["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    PracticeProblemType["MULTI_PART"] = "MULTI_PART";
})(PracticeProblemType || (exports.PracticeProblemType = PracticeProblemType = {}));
var ProblemSetType;
(function (ProblemSetType) {
    ProblemSetType["EXAM"] = "Exam";
    ProblemSetType["QUIZ"] = "Quiz";
    ProblemSetType["LESSON"] = "Lesson";
})(ProblemSetType || (exports.ProblemSetType = ProblemSetType = {}));
exports.MINIMUM_PROBLEM_SET_SIZE = 1;
//# sourceMappingURL=consts.js.map